exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".alert[data-v-5d3f01cb]{min-height:0!important;color:#00f!important}.bold[data-v-5d3f01cb]{font-weight:700!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5d3f01cb","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/profile/views/career-guidance/components/smart/Smart.vue
// module id = 4e4773308d574c3653ba
// module chunks = 4